module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "col-xs-12 corte2 footer"
  }, [_c('div', {
    staticClass: "col-xs-12 footer__top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 footer__segui"
  }, [_c('div', {
    staticClass: "shadow footer__wrp"
  }, [_c('h3', [_vm._v("SEGUINOS EN REDES SOCIALES")]), _vm._v(" "), _c('ul', _vm._l((_vm.sm), function(value, key) {
    return _c('li', [_c('a', {
      attrs: {
        "href": value,
        "target": "_blank"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(key.split('-')[1].toUpperCase())
      }
    }), _vm._v(" "), _c('i', {
      class: 'fa ' + key
    })])])
  }))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer__bar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.theme_url + '/html/assets/img/logo.png',
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("©2017 " + _vm._s(_vm.site_name))])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 footer__suscribete"
  }, [_c('div', {
    staticClass: "footer__wrp"
  }, [_c('h3', [_vm._v("SUSCRIBIRTE A NUESTRO"), _c('br'), _vm._v("NEWSLETTER")]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "https://newsletter.cerocin.co/subscribe",
      "method": "POST",
      "accept-charset": "utf-8",
      "target": "_blank"
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "list",
      "value": "wuBzgEyMO0RAk5ue892l8KXA"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "name": "submit",
      "id": "submit"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-xs-6 text-right"
  }, [_c('a', {
    attrs: {
      "href": "https://cerocin.co"
    }
  }, [_vm._v("Desarrollado por Cerocinco")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3675a13e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/theme-footer.vue
// module id = 125
// module chunks = 0